import type { PaginatedDataTableColumnConfig } from '../types/paginatedDataTableTypes';

export type align = 'left' | 'center' | 'right';

export const convertColumnConfigToPaginatedDataTableColumnConfig = (
  columns: PaginatedDataTableColumnConfig[],
  t: (key: string) => string,
): PaginatedDataTableColumnConfig[] => {
  const tableProperties = columns.map((col) => {
    const baseKey = col.header ?? col.field;
    const align: align = col.align ?? 'left';

    return {
      ...col,
      title: t(`labels.${baseKey}`),
      header: baseKey,
      align,
    };
  });

  return tableProperties;
};

export const getResponsiveHeaderLabel = (
  col: PaginatedDataTableColumnConfig,
  t: (key: string) => string,
): string => {
  const baseKey = col.header;
  const fullKey = `labels.${baseKey}`;
  const key = col.needShortHeader ? `labels.${baseKey}Short` : fullKey;

  return t(key);
};

export const rowsPerPageOptions = [10, 20, 50];
